import { Component, inject, Input, OnInit } from '@angular/core';
import { SmallTuileComponent } from '../../../../../../../../components/ecosystems/small-tuile/small-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { TuileButtonProps } from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { getTemperature } from '../../../../../../helper/temperature';

@Component({
  selector: 'app-p00061-card-chauffage-statut',
  templateUrl: './p00061-card-chauffage-statut.component.html',
  styleUrls: ['./p00061-card-chauffage-statut.component.scss'],
  imports: [SmallTuileComponent, TranslatePipe],
})
export class P00061CardChauffageStatutComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];
  public buttonMode: TuileButtonProps[] = [];

  public titles: string[] = [
    'P00061.card.state.fonctionnement.title.cold',
    'P00061.card.state.fonctionnement.title.hot',
    'P00061.card.state.fonctionnement.title.auto',
  ];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttonMode = [
      {
        title: 'P00061.dashboard.card.status.off',
        icon: 'off',
        color: 'color-red',
        status: 'inactive',
      },
      {
        title: 'P00061.dashboard.card.status.on',
        icon: 'on',
        color: 'color-green',
        status: 'active',
      },
    ];

    this.buttons = [
      {
        title: 'P00061.card.state.fonctionnement.title.off',
        icon: 'fa-kit fa-picto-off',
        color: 'color-red',
      },
      {
        title: 'P00061.card.state.fonctionnement.title.on',
        icon: 'fa-kit fa-picto-on',
        color: 'color-green',
      },
      {
        title: 'P00031.card.state.fonctionnement.title.clock',
        icon: 'fa-kit fa-picto-horloge',
        color: 'color-orange',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.PAC,
      FunctionOnglet.CONTROL,
      this.titles[
        this.actionStack!.getValue('wpPModeFonctionnementTemperature')
      ],
    );
  }

  protected readonly getTemperature = getTemperature;
}
